import * as React from 'react';
import classnames from 'classnames';
import { Summary, DateTime, Price } from '@grandvisionhq/common';
import { Hr, Label } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import DetailHeader from '../../../components/DetailHeader/DetailHeader.js';

const TotalPrice = ({ label , totalPrice  })=>/*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement("span", null, label, " "), /*#__PURE__*/ React.createElement(Price, {
        value: totalPrice.amount,
        currency: totalPrice.currency
    }))
;
const CCCHeader = ({ expiryDate , totalPrice , className , deliveryFrequency , disabled , nextDelivery , status , dueDate ,  })=>{
    const { getLabel , locale , dateTime  } = useIntl();
    const isExpired = status === 'EXPIRED';
    const deliveryFrequencyLabel = getDeliveryFrequencyLabel(deliveryFrequency, getLabel);
    const durationDefinition = isExpired ? `2 ${getLabel('common.duration.years')} - ${getLabel(`account.ccc.status.expired`)}` : `2 ${getLabel('common.duration.years')}`;
    return /*#__PURE__*/ React.createElement(Summary, {
        className: classnames('ccc-header subscription__summary', className, {
            'ccc-header--disabled': disabled
        })
    }, /*#__PURE__*/ React.createElement(DetailHeader, {
        className: "ccc-header__info"
    }, /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.ccc.length') + ': ',
        definition: durationDefinition
    }), deliveryFrequency && /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.ccc.deliveryFrequency') + ': ',
        definition: deliveryFrequencyLabel
    }), /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.ccc.nextDelivery') + ': ',
        definition: nextDelivery ? /*#__PURE__*/ React.createElement(DateTime, {
            dateTime: new Date(nextDelivery.date),
            locale: locale
        }) : getLabel('account.ccc.nextDelivery.unavailable')
    }), dueDate ? /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.subscription.payment.dueDate') + ': ',
        definition: dateTime.formatMidsizeDate(new Date(dueDate))
    }) : null, /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: /*#__PURE__*/ React.createElement(TotalPrice, {
            label: getLabel('common.total') + ': ',
            totalPrice: totalPrice
        }),
        definition: getLabel('common.frequency.perMonth')
    })), /*#__PURE__*/ React.createElement(Hr, {
        className: "ccc-header__horizontal-rule"
    }), !isExpired && /*#__PURE__*/ React.createElement(Label, {
        type: "neutral"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, getLabel(`account.ccc.expiryDate`) + ': ', /*#__PURE__*/ React.createElement(DateTime, {
        dateTime: expiryDate,
        locale: locale
    }))));
};
function getDeliveryFrequencyLabel(label, getLabel) {
    if (!label) {
        return undefined;
    }
    switch(label){
        case 'ANNUALLY':
            return getLabel('common.frequency.yearly');
        case 'BI_WEEKLY':
            return getLabel('common.frequency.biweekly');
        default:
            return getLabel(`common.frequency.${label.toLowerCase()}`);
    }
}
var CCCHeader$1 = CCCHeader;

export { CCCHeader$1 as default, getDeliveryFrequencyLabel };
//# sourceMappingURL=CCCHeader.js.map
